<button
  nz-button
  [nzBlock]="fullSize"
  nzSize="large"
  (click)="openLotAddCarInspectionAdminFormModal()"
>
  <i nz-icon nzType="diff" nzTheme="outline"></i>
  <span *ngIf="fullSize">
    {{ 'ADD_CAR_INSPECTION.TITLE' | translate }}
  </span>
</button>
